import React, { useEffect, useState } from 'react';
import hostsData from '../../data/hosts.json'; // Importa el JSON
import '../../styles/Home.css';

const Host = () => {
    const [hosts, setHosts] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        setHosts(hostsData); // Carga las imágenes desde el JSON

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            updateAOSDelay();
        };

        const updateAOSDelay = () => {
            const images = document.querySelectorAll('.host-section img');
            images.forEach(img => {
                if (window.innerWidth < 768) {
                    img.removeAttribute('data-aos-delay'); // Elimina el delay en móviles
                } else {
                    const delayValue = img.getAttribute('data-original-delay');
                    if (delayValue) {
                        img.setAttribute('data-aos-delay', delayValue);
                    }
                }
            });
        };

        updateAOSDelay(); // Ejecutar al cargar la página
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className="host-section">
            <div className='container'>
                {/* Título */}
                <div className="title-container mt-5" data-aos="fade-up" data-aos-offset="50">
                    <h2 className="title"><span>CONOCE A PARTE DE</span> LOS HOST</h2>
                    <h3 className='subtitle'>QUE MAXIMIZAN EL MENSAJE EN NUESTRAS INICIATIVAS</h3>
                    <div className="title-underline"></div>
                </div>

                <div className='row d-flex justify-content-center text-center m-2' data-aos="flip-right">
                    <div className='col-md-8 host-description p-4'>
                        <p className='m-0'>Mariliana Torres - Silverio Pérez - Lily García - Braulio Castillo
                            Pepe Calderón - Shanira Blanco - Bebé Maldonado - María del Carmen González - Wilenie Sepúlveda
                        </p>
                        <p className='m-0'>Entre otros…</p>
                    </div>
                </div>

                <div className='row d-flex justify-content-center text-center m-2 pt-3' data-aos="fade-up">
                    <div className='col-md-12 host-description-text'>
                        <p>Seleccionamos figuras que conecten con la gente a través de su trayectoria y experiencia en
                            periodismo de salud, pero también, que tenga una comunidad amplia de personas que los siguen,
                            para llegar a la mayor cantidad de personas posible a través de medios de comunicación tradicionales
                            y digitales.
                        </p>
                    </div>
                </div>

                {/* Imágenes desde JSON con ajuste responsive */}
                <div className={`row ${isMobile ? 'd-flex justify-content-center' : ''}`}>
                    {hosts.map((item, index) => (
                        <div className={`col ${isMobile ? 'col-5' : ''}`} key={index}>
                            <img
                                src={item.src}
                                alt="host"
                                data-aos="zoom-out"
                                data-aos-delay={item.delay}
                                data-original-delay={item.delay} // Guarda el delay original para restaurarlo en desktop
                                className='img-filter'
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Host;

